import { HttpRequest } from '../utils';

import { createLogger } from '../utils/logger';
const logger = createLogger('services');

/**
 * Per-(date, model) bucket returned by the backend aggregator.
 */
export interface AgentUsageBucket {
    date: string;
    model: string;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
    costUsd: number;
    callCount: number;
}

export interface AgentUsageSummary {
    chatbotId: string;
    from: string;
    to: string;
    totalCostUsd: number;
    totalTokens: number;
    totalCalls: number;
    buckets: AgentUsageBucket[];
}

interface AgentUsageResponse {
    data: AgentUsageSummary;
}

const request = new HttpRequest('config.endpoints.metrics');

export const agentUsageService = {
    /**
     * Retrieves aggregated LLM usage for an agent over the given date range. Both `from`
     * and `to` are inclusive `YYYY-MM-DD` dates in UTC; omit them to let the backend
     * default to the current calendar month.
     */
    async getAgentUsage(chatbotId: string, from?: string, to?: string): Promise<AgentUsageSummary> {
        try {
            const queryParams: Record<string, string> = {};
            if (from) queryParams.from = from;
            if (to) queryParams.to = to;

            const response = await request.get(`agents/${chatbotId}/llm-usage`, queryParams);

            if (response.status === 200 && response.data) {
                const apiResponse = response.data as AgentUsageResponse;
                return apiResponse.data;
            }

            throw new Error(`Failed to fetch agent usage. Status: ${response.status}`);
        } catch (error) {
            logger.error(`Error fetching LLM usage for chatbot ${chatbotId}:`, error);
            throw new Error(`Failed to fetch LLM usage for agent ${chatbotId}`);
        }
    },
};
